import { CategoriaEnum, Categorias } from '@acme/auth'
import { helpers } from '@acme/core'
import { Divider } from '@mui/material'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import Cookies from 'js-cookie'
import {
    BriefcaseBusinessIcon,
    CircleUserRoundIcon,
    CodeXml,
    CodeXmlIcon,
    ContactRoundIcon,
    HistoryIcon,
    LogOutIcon,
    ShieldUserIcon,
    UserIcon,
    UsersRoundIcon,
} from 'lucide-react'
import tokenRefresher from 'service/api/token-refresher'
import { toast } from 'sonner'
import { useStore } from 'store'
import IconButton from '../Button/IconButton'
import DevelopmentOnly from '../DevelpmentOnly'
import Menu from '../MenuV2'

export default function ProfileMenu() {
    const tokenSuporte = Cookies.get('tokenSuporte')
    const {
        decoded: { categoria, email, nome, sub },
        handleLogout,
    } = useAuth()

    async function handleLoginSuporte() {
        if (!tokenSuporte) return
        useStore.persist.clearStorage()
        Cookies.set('refreshToken', tokenSuporte, {
            expires: 1,
            sameSite: 'lax',
        })
        Cookies.remove('JWT')
        Cookies.remove('tokenSuporte')
        await tokenRefresher.refreshToken()
        window.location.href = '/'
    }

    async function handleRefreshToken() {
        return tokenRefresher
            .refreshToken()
            .then(() => {
                toast.success('Token de acesso atualizado com sucesso!')
                setTimeout(() => {
                    window.location.reload()
                }, 500)
            })
            .catch(err =>
                toast.error(`Erro ao atualizar o token: ${err?.message}`),
            )
    }

    return (
        <Menu.Root arrow position="right" key="profile-menu">
            <Menu.Trigger>
                <IconButton className="p-0.5" title="Opções do perfil">
                    <CircleUserRoundIcon className="size-8 text-primary-foreground" />
                </IconButton>
            </Menu.Trigger>
            <Menu.List>
                <div
                    className="flex items-center gap-3 px-4 py-2 select-none"
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                >
                    <div className="flex size-11 items-center justify-center rounded-full border aspect-1/1">
                        <UserIcon className="size-7" />
                    </div>
                    <div className="flex flex-col min-w-0">
                        <span className="text-md truncate max-w-45 select-text">
                            {nome}
                        </span>
                        <span
                            className="text-md truncate max-w-45 select-text"
                            title={email}
                        >
                            {nome ||
                                (helpers.isCPF(email)
                                    ? email.replace(
                                          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                                          '$1.$2.$3-$4',
                                      )
                                    : email)}
                        </span>
                        <span className="text-sm truncate max-w-45">
                            {[
                                CategoriaEnum.Cliente,
                                CategoriaEnum.Avaliacao,
                            ].includes(categoria)
                                ? 'Cliente'
                                : Categorias[
                                      categoria as keyof typeof Categorias
                                  ] || 'Cliente'}
                            <DevelopmentOnly>
                                <span
                                    title={String(sub)}
                                    className="text-xs inline-flex gap-1 opacity-70 ml-2"
                                >
                                    <CodeXml className="size-3.5" />
                                    UserID: {sub}
                                </span>
                            </DevelopmentOnly>
                        </span>
                    </div>
                </div>
                <Divider className="my-1" />
                {hasPermission(['read', 'Perfil']) && (
                    <Menu.Item href="perfil">
                        <Menu.Item.Icon>
                            <ContactRoundIcon />
                        </Menu.Item.Icon>
                        <Menu.Item.Text>Perfil e segurança</Menu.Item.Text>
                    </Menu.Item>
                )}
                {[CategoriaEnum.Cliente, CategoriaEnum.Avaliacao].includes(
                    categoria,
                ) && (
                    <Menu.Item href="/planos/me">
                        <Menu.Item.Icon>
                            <BriefcaseBusinessIcon />
                        </Menu.Item.Icon>
                        <Menu.Item.Text>Meu plano</Menu.Item.Text>
                    </Menu.Item>
                )}
                {categoria === CategoriaEnum.Funcionario && (
                    <Menu.Item href="/selecionar-funcionario">
                        <Menu.Item.Icon>
                            <UsersRoundIcon />
                        </Menu.Item.Icon>
                        <Menu.Item.Text>Trocar funcionário</Menu.Item.Text>
                    </Menu.Item>
                )}
                {hasPermission(['read', 'Alterações'], () => (
                    <Menu.Item href="/alteracoes">
                        <Menu.Item.Icon>
                            <HistoryIcon />
                        </Menu.Item.Icon>
                        <Menu.Item.Text>Alterações</Menu.Item.Text>
                    </Menu.Item>
                ))}
                <Divider className="my-1" />
                {!!tokenSuporte && (
                    <Menu.Item onClick={handleLoginSuporte}>
                        <Menu.Item.Icon>
                            <ShieldUserIcon />
                        </Menu.Item.Icon>
                        <Menu.Item.Text>
                            Voltar ao login administrativo
                        </Menu.Item.Text>
                    </Menu.Item>
                )}
                <DevelopmentOnly>
                    <Menu.Item
                        onClick={handleRefreshToken}
                        className="opacity-70"
                    >
                        <Menu.Item.Icon>
                            <CodeXmlIcon />
                        </Menu.Item.Icon>
                        <Menu.Item.Text>Refresh token</Menu.Item.Text>
                    </Menu.Item>
                </DevelopmentOnly>
                <Menu.Item onClick={handleLogout}>
                    <Menu.Item.Icon>
                        <LogOutIcon />
                    </Menu.Item.Icon>
                    <Menu.Item.Text>Sair</Menu.Item.Text>
                </Menu.Item>
            </Menu.List>
        </Menu.Root>
    )
}
